import { render } from "./TableItem.vue?vue&type=template&id=a1dce1d8&scoped=true"
import script from "./TableItem.vue?vue&type=script&lang=ts"
export * from "./TableItem.vue?vue&type=script&lang=ts"

import "./TableItem.vue?vue&type=style&index=0&id=a1dce1d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a1dce1d8"

export default script